<div class="tr md-no-proxy hover layout-row layout-align-start-center">

  <!--Contact-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{operationalContact.fullName || operationalContact.name}}</span>
  </div>

  <!--Type-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{operationalContact.contactType}}</span>
  </div>

  <!--Phone Number-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{operationalContact.phoneNo | bringozPhone}}</span>
  </div>

</div>
